import React, { useMemo } from 'react'
import { Box } from '@mui/material'
import MuiSelect from '@mui/material/Select'
import FormControl from '@mui/material/FormControl/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import TextField from '../TextField'

const sx = {
  icon: {
    right: 10,
    position: 'absolute',
    pointerEvents: 'none',
    color: '#9292AF',
    borderRadius: '5px',
    backgroundColor: '#F4F4F7',
    marginBottom: '3px',
  },
}

export const SelectField = props => {
  const { label, name, value, onChange, children, open, helperText, error, width, borderLess, disabled } = props
  const id = useMemo(() => Math.random().toString(32).substr(3), [])

  return (
    <FormControl style={{ width }}>
      {label && <InputLabel id={id}>{label}</InputLabel>}
      <MuiSelect
        labelId={id}
        name={name}
        value={value}
        onChange={onChange}
        open={open}
        borderLess={borderLess}
        disabled={disabled}
        IconComponent={Icon}
        MenuProps={{
          PaperProps: {
            style: {
              transform: 'translate(0px, -1px)',
              color: '#25245f',
              padding: '8px',
              marginTop: '10px',
              boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
              borderRadius: '5px',
              maxHeight: 200
            },
          },
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
          },
          transformOrigin: {
            vertical: 'top',
            horizontal: 'left',
          },
        }}
        input={<TextField width="140px" />}
      >
        {children}
      </MuiSelect>
      {helperText && <FormHelperText error={error}>{helperText}</FormHelperText>}
    </FormControl>
  )
}

const Icon = () => {

  return (
    <Box sx={sx.icon}>
      <ArrowDropDownIcon fontSize="large" />
    </Box>
  )
}

export default SelectField
